export default {
  brand: {
    primary: '#70CBF4',
    secondary: '#FCB712',
    tertiary: '#E3A103',
    quaternary: '#000000',
  },
};
